import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery

$.ajaxPrefilter(function (options, originalOptions, xhr) {
  if (!options.crossDomain) {
    const token = $('meta[name="csrf-token"]').attr('content')
    if (token) xhr.setRequestHeader('X-CSRF-Token', token)
  }
})
